import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { selectAllLocations, selectCurrentLocation } from '../../../stores/locations/locations.selector';
import { LocationAddModalComponent } from '../location-add-modal/location-add-modal.component';

@Component({
  selector: 'era-location-selector',
  templateUrl: './location-selector.container.html',
  styleUrls: ['./location-selector.container.scss'],
  imports: [NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem, RouterLink],
})
export class LocationSelectorContainerComponent {
  private readonly store = inject(Store);
  private readonly modalService = inject(NgbModal);

  public readonly location = this.store.selectSignal(selectCurrentLocation);
  public readonly locations = this.store.selectSignal(selectAllLocations);

  public openAddLocationModal(): void {
    this.modalService.open(LocationAddModalComponent);
  }
}
